import React from 'react';

import { CreditCardTypeId } from '@r6digital/rapidstor-types/enums/sitelink';

interface Props {
    typeId: CreditCardTypeId | undefined;
    className?: string;
}

function VisaIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" role="img" aria-label="Visa">
            <rect width="48" height="32" rx="4" fill="#1a1f71" />
            <text x="50%" y="22" textAnchor="middle" fill="white" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fontStyle="italic" letterSpacing="1">VISA</text>
        </svg>
    );
}

function MastercardIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" role="img" aria-label="Mastercard">
            <rect width="48" height="32" rx="4" fill="#252525" />
            <circle cx="18" cy="16" r="10" fill="#eb001b" />
            <circle cx="30" cy="16" r="10" fill="#f79e1b" />
            <path d="M24 8.3a10 10 0 0 1 0 15.4A10 10 0 0 1 24 8.3z" fill="#ff5f00" />
        </svg>
    );
}

function AmexIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" role="img" aria-label="American Express">
            <rect width="48" height="32" rx="4" fill="#2557d6" />
            <text x="50%" y="22" textAnchor="middle" fill="white" fontFamily="Arial, sans-serif" fontSize="10" fontWeight="bold" letterSpacing="0.5">AMEX</text>
        </svg>
    );
}

function DiscoverIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" role="img" aria-label="Discover">
            <rect width="48" height="32" rx="4" fill="#fff" stroke="#e0e0e0" strokeWidth="1" />
            <text x="4" y="14" fill="#231f20" fontFamily="Arial, sans-serif" fontSize="7" fontWeight="bold">DISC</text>
            <text x="4" y="23" fill="#231f20" fontFamily="Arial, sans-serif" fontSize="7" fontWeight="bold">OVER</text>
            <circle cx="37" cy="16" r="11" fill="#f76f20" />
        </svg>
    );
}

function DinersIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" role="img" aria-label="Diners Club">
            <rect width="48" height="32" rx="4" fill="#fff" stroke="#e0e0e0" strokeWidth="1" />
            <circle cx="19" cy="16" r="9" fill="none" stroke="#004a97" strokeWidth="2" />
            <circle cx="29" cy="16" r="9" fill="none" stroke="#004a97" strokeWidth="2" />
        </svg>
    );
}

function GenericCardIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" role="img" aria-label="Credit card">
            <rect width="48" height="32" rx="4" fill="#e8e8e8" />
            <rect x="4" y="10" width="12" height="9" rx="2" fill="#bbb" />
            <rect x="4" y="23" width="8" height="2" rx="1" fill="#ccc" />
            <rect x="14" y="23" width="8" height="2" rx="1" fill="#ccc" />
            <rect x="24" y="23" width="8" height="2" rx="1" fill="#ccc" />
        </svg>
    );
}

export default function CardBrandIcon({ typeId, className }: Props) {
    const icon = () => {
        switch (typeId) {
            case CreditCardTypeId.Visa: return <VisaIcon />;
            case CreditCardTypeId.Mastercard: return <MastercardIcon />;
            case CreditCardTypeId.AmericanExpress: return <AmexIcon />;
            case CreditCardTypeId.Discover: return <DiscoverIcon />;
            case CreditCardTypeId.Diners: return <DinersIcon />;
            default: return <GenericCardIcon />;
        }
    };

    return (
        <span className={className}>
            {icon()}
        </span>
    );
}
